import { render, staticRenderFns } from "./BankingView.vue?vue&type=template&id=bac3c2b8&scoped=true&"
import script from "./BankingView.vue?vue&type=script&lang=js&"
export * from "./BankingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac3c2b8",
  null
  
)

export default component.exports